<template>
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3491_2784)">
      <path
        d="M7 13L1 7L7 1"
        stroke="#040325"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3491_2784">
        <rect
          width="8"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
